import { chatEventEmitter } from '@wix/chat-sdk';
import _noop from 'lodash/noop';
import _size from 'lodash/size';
import _findIndex from 'lodash/findIndex';
import _get from 'lodash/get';
import i18n from '../../i18n';
export var CHANGE_TITLE_INTERVAL = 2000;
var TitleManager = /** @class */ (function () {
    function TitleManager(_a) {
        var defaultTitle = _a.defaultTitle, setTitleCb = _a.setTitleCb, locale = _a.locale;
        this.setTitleCb = _noop;
        this.defaultTitle = defaultTitle;
        this.setTitleCb = setTitleCb;
        this.unreadMessageChatroomsIds = [];
        this.titleIntervalIndex = 0;
        this.i18nextInstance = i18n({ locale: locale });
        this.addTitleListener();
    }
    TitleManager.prototype.startChangeTitleInterval = function () {
        var _this = this;
        this.changeTitleIntervalId = setInterval(function () {
            if (_size(_this.unreadMessageChatroomsIds) <= _this.titleIntervalIndex) {
                _this.setTitleCb(_this.defaultTitle);
                _this.titleIntervalIndex = 0;
            }
            else {
                var senderName = _this.unreadMessageChatroomsIds[_this.titleIntervalIndex].senderName;
                var newTitle = senderName
                    ? _this.i18nextInstance.t('unread.messages.title.name', {
                        name: senderName,
                    })
                    : _this.i18nextInstance.t('unread.messages.title.generic');
                _this.setTitleCb(newTitle);
                _this.titleIntervalIndex++;
            }
        }, CHANGE_TITLE_INTERVAL);
    };
    TitleManager.prototype.addTitleListener = function () {
        chatEventEmitter.addListener(chatEventEmitter.CHAT_EVENTS.NEW_REALTIME_MESSAGE, this.handleMessageReceived.bind(this));
        chatEventEmitter.addListener(chatEventEmitter.CHAT_EVENTS.MESSAGES_READ, this.handleMessageRead.bind(this));
    };
    TitleManager.prototype.removeTitleListener = function () {
        chatEventEmitter.removeListener(chatEventEmitter.CHAT_EVENTS.NEW_REALTIME_MESSAGE, this.handleMessageReceived.bind(this));
        chatEventEmitter.removeListener(chatEventEmitter.CHAT_EVENTS.MESSAGES_READ, this.handleMessageRead.bind(this));
    };
    TitleManager.prototype.handleMessageReceived = function (message) {
        var chatroomIndex = _findIndex(this.unreadMessageChatroomsIds, [
            'chatroomId',
            message.chatroomId,
        ]);
        if (chatroomIndex !== -1) {
            return;
        }
        this.unreadMessageChatroomsIds.push({
            chatroomId: message.chatroomId,
            senderName: _get(message, 'senderDisplayData.name'),
        });
        if (_size(this.unreadMessageChatroomsIds) === 1) {
            this.startChangeTitleInterval();
        }
    };
    TitleManager.prototype.handleMessageRead = function (chatroomId) {
        var chatroomIndex = _findIndex(this.unreadMessageChatroomsIds, [
            'chatroomId',
            chatroomId,
        ]);
        if (chatroomIndex === -1) {
            return;
        }
        this.unreadMessageChatroomsIds.splice(chatroomIndex, 1);
        if (!_size(this.unreadMessageChatroomsIds)) {
            this.resetTitleToDefault();
        }
    };
    TitleManager.prototype.resetTitleToDefault = function () {
        clearInterval(this.changeTitleIntervalId);
        this.setTitleCb(this.defaultTitle);
    };
    TitleManager.prototype.stop = function () {
        this.removeTitleListener();
        this.resetTitleToDefault();
    };
    return TitleManager;
}());
var TitleManagerFactory = /** @class */ (function () {
    function TitleManagerFactory() {
    }
    TitleManagerFactory.prototype.createTitleManager = function (titleManager) {
        return new TitleManager(titleManager);
    };
    return TitleManagerFactory;
}());
export var titleManagerFactory = new TitleManagerFactory();
//# sourceMappingURL=title-manager.js.map